import { useTicketPriorities } from "@jugl-web/domain-resources/tickets/hooks/useTicketPriorities";
import { UpdateTicketPayload } from "@jugl-web/rest-api";
import { TicketPriority } from "@jugl-web/rest-api/tickets/models/common-types";
import { TicketListItemModel } from "@jugl-web/rest-api/tickets/models/TicketListItem";
import { TableCell } from "@jugl-web/ui-kit";
import { TicketPriorityPickerPopover } from "@web-src/modules/client-support/components/TicketPriorityPickerPopover";
import { TicketPropertyPill } from "@jugl-web/domain-resources/tickets/components/TicketPropertyPill";
import { FC, useCallback, useMemo } from "react";
import { AppearingPlaceholderText } from "../AppearingPlaceholderText";
import { ReactComponent as FlagBlankIcon } from "./assets/flag-blank.svg";

interface PriorityCellContentProps {
  ticket: TicketListItemModel;
  onUpdate: (data: UpdateTicketPayload) => void;
}

export const PriorityCellContent: FC<PriorityCellContentProps> = ({
  ticket,
  onUpdate,
}) => {
  const { getPriorityById } = useTicketPriorities();

  const priorityDetails = useMemo(
    () => getPriorityById(ticket.priority),
    [ticket.priority, getPriorityById]
  );

  const handlePriorityChange = useCallback(
    (priority: TicketPriority) => {
      onUpdate({ priority });
    },
    [onUpdate]
  );

  return (
    <TicketPriorityPickerPopover
      priority={ticket.priority}
      onChange={handlePriorityChange}
      renderTrigger={({ Trigger, triggerRef, isOpen }) => (
        <Trigger
          as={TableCell}
          ref={triggerRef}
          isFocused={isOpen}
          isHoverable
          classNames={{ content: "min-w-0" }}
        >
          {ticket.priority !== "none" ? (
            <TicketPropertyPill
              icon={priorityDetails.icon}
              label={priorityDetails.label}
            />
          ) : (
            <AppearingPlaceholderText
              icon={<FlagBlankIcon />}
              label="Set priority"
              isStatic={isOpen}
            />
          )}
        </Trigger>
      )}
    />
  );
};
